import React, { useEffect, useState } from "react"
import { Tabs, Button, Card } from 'antd';

import General from './components/General'
import Rooms from './components/Rooms'
import styles from '.././index.module.css'

const { TabPane } = Tabs;


const MeetingRooms = (props: any) => {
    const [editFlag, setEditFlag] = useState<boolean>(false)
    const [currentTab, setCurrentTab] = useState<boolean>(true)
    const [generalData, setGeneralData] = useState<object>(props?.allAPIdata?.meetingrooms)
    const [activityKey, setActivityKey] = useState<string>(props.meetingroomTabsActivityKey)
    const tableData = props?.allAPIdata?.meetingrooms?.meetingroom || []


    useEffect(() => {
        props.meetingroomTabsActivityKey === '1' ? setCurrentTab(true) : setCurrentTab(false);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
    
    const tabsChange = (key: string) => {
        key === '1' ? setCurrentTab(true) : setCurrentTab(false);
        setActivityKey(key)
    }
    const edit = <Button className='db-add-btn' onClick={() => { setEditFlag(true); window.editFunction(); props.setOneNavDisabled(true) }}>Edit</Button>

    const add = <Button className='db-edit-btn' onClick={() => { props.setCurrentOneNav('add') }}>Add</Button>

    return (
        <>
            <Card className={styles.margin16}>
                <Tabs defaultActiveKey="1" onChange={tabsChange} type="card" tabBarExtraContent={(!editFlag && currentTab) ? edit : (!editFlag && !currentTab) ? add : ''} activeKey={activityKey}>
                    <TabPane tab="General" key="1" disabled={props.OneNavDisabled}>
                        <General
                            generalData={generalData}
                            setGeneralData={setGeneralData}
                            setEditFlag={setEditFlag}
                            setOneNavDisabled={props.setOneNavDisabled}
                            editFlag={editFlag}
                        /> 
                    </TabPane>
                    <TabPane tab="Meeting Rooms" key="2" disabled={props.OneNavDisabled}>
                        <Rooms tableData={tableData} setCurrentLine={props.setCurrentLine} setCurrentOneNav={props.setCurrentOneNav} />
                    </TabPane>
                </Tabs>
            </Card>
        </>
    )
}

export default MeetingRooms
